import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const theme: ThemeApp['appComponents']['loginMigrations'] = {
  redisBackground: {
    color: themeUi.semantic.color.text.neutral100
  }
};

export default theme;
